$(document).ready(function () {


  //  search modal js main banner start
  // $('.site-nav__link').on('click', function (e) {
  //   e.preventDefault(); 

    
  //   $('.site-nav__link').removeClass('active-link');

  
  //   $(this).addClass('active-link');
  // });

  $('.section_Search').on('click', function () {
    $('.destination-modal').show();
  });

  $('.close-modal').on('click', function () {
    $('.destination-modal').hide();
  });

  
  $('.destination-modal').on('click', function (e) {
    if ($(e.target).is('.destination-modal')) {
      $(this).hide();
    }
  });

  const countryFlags = {
    
     oman: `
<?xml version="1.0" encoding="iso-8859-1"?>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg class="flag oman" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<rect y="85.331" style="fill:#D80027;" width="512" height="341.326"/>
	<rect y="85.331" style="fill:#D80027;" width="512" height="341.337"/>
</g>
<g>
	<polygon style="fill:#F0F0F0;" points="189.746,160.439 174.007,144.698 163.513,155.192 153.02,144.698 137.279,160.439 
		147.773,170.932 137.278,181.426 153.018,197.167 163.512,186.673 174.007,197.167 189.746,181.426 179.252,170.932 	"/>
	<rect x="211.478" y="85.331" style="fill:#F0F0F0;" width="300.522" height="111.315"/>
</g>
<rect x="211.478" y="315.353" style="fill:#6DA544;" width="300.522" height="111.304"/>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>`,

      romania: `
<?xml version="1.0" encoding="iso-8859-1"?>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg class="flag romania" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<rect y="85.331" style="fill:#FFDA44;" width="512" height="341.326"/>
<rect y="85.331" style="fill:#0052B4;" width="170.663" height="341.337"/>
<rect x="341.337" y="85.331" style="fill:#D80027;" width="170.663" height="341.337"/>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>  `,
    
      israel: `
<?xml version="1.0" encoding="iso-8859-1"?>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg class="flag israel"  version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<rect y="85.331" style="fill:#F0F0F0;" width="512" height="341.337"/>
<g>
	<path style="fill:#2E52B2;" d="M320,219.045h-42.667L256,182.094l-21.333,36.95H192l21.335,36.951L192,292.944h42.667L256,329.895
		l21.333-36.95H320l-21.335-36.951L320,219.045z M282.209,255.994l-13.104,22.699h-26.209l-13.105-22.699l13.105-22.699h26.209
		L282.209,255.994z M256,210.597l4.877,8.448h-9.754L256,210.597z M216.685,233.295h9.755l-4.877,8.448L216.685,233.295z
		 M216.685,278.694l4.877-8.448l4.877,8.448H216.685z M256,301.392l-4.876-8.448h9.754L256,301.392z M295.315,278.694h-9.755
		l4.877-8.448L295.315,278.694z M285.56,233.295h9.755l-4.877,8.448L285.56,233.295z"/>
	<rect y="106.657" style="fill:#2E52B2;" width="512" height="42.663"/>
	<rect y="362.657" style="fill:#2E52B2;" width="512" height="42.663"/>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>   ` ,
     romania: `
    <svg class="flag romania" id="Layer_1" enable-background="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m345.043 15.922c-27.734-10.289-57.729-15.922-89.043-15.922-31.314-.001-61.31 5.633-89.043 15.922l-22.261 240.077 22.261 240.077c27.732 10.292 57.728 15.924 89.043 15.924 31.313 0 61.31-5.632 89.043-15.924l22.26-240.076z" fill="#ffda44"/><path d="m512 256c0-110.07-69.472-203.907-166.957-240.077v480.156c97.485-36.174 166.956-130.007 166.957-240.079z" fill="#d80027"/><path d="m0 255.999c0 110.073 69.472 203.906 166.955 240.079l.001-480.154c-97.484 36.17-166.956 130.004-166.956 240.075z" fill="#0052b4"/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/></svg>
  `,

    
    india: `
      <?xml version="1.0" encoding="iso-8859-1"?>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg  class="flag india"  version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<rect y="85.337" style="fill:#F0F0F0;" width="512" height="341.326"/>
<rect y="85.337" style="fill:#FF9811;" width="512" height="113.775"/>
<rect y="312.888" style="fill:#6DA544;" width="512" height="113.775"/>
<circle style="fill:#0052B4;" cx="256" cy="256" r="43.896"/>
<circle style="fill:#F0F0F0;" cx="256" cy="256" r="27.434"/>
<polygon style="fill:#0052B4;" points="256,222.146 264.464,241.341 285.319,239.073 272.927,256 285.319,272.927 264.464,270.659 
	256,289.854 247.536,270.659 226.681,272.927 239.073,256 226.681,239.073 247.536,241.341 "/>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
  `,
     egypt: `
<?xml version="1.0" encoding="iso-8859-1"?>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg class="flag egypt" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<rect y="85.337" style="fill:#F0F0F0;" width="512" height="341.326"/>
<rect y="85.337" style="fill:#D80027;" width="512" height="113.775"/>
<rect y="312.888" width="512" height="113.775"/>
<path style="fill:#FF9811;" d="M320,236.29h-48c0-8.836-7.164-16-16-16s-16,7.164-16,16h-48c0,8.836,7.697,16,16.533,16H208
	c0,8.836,7.164,16,16,16c0,8.836,7.164,16,16,16h32c8.836,0,16-7.164,16-16c8.836,0,16-7.164,16-16h-0.533
	C312.303,252.29,320,245.127,320,236.29z"/>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>  `,
    
      
     default: `
    <svg class="flag default-flag" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
      <rect width="100%" height="100%" fill="none" />
    </svg>
  `
  };
  

 var SearchResultJson = [
    {
        country_name: "africa",
        country_handle: "africa",
        country_title: [
            { name: "Chad", search_name: "chad", handle_name: "chad", link: "/collections/worldsims"},
            {
                name: "Democratic Republic of the Congo",
                search_name: "democratic-republic-of-the-congo",
                handle_name: "democratic-republic-of-the-congo",
                link: "/collections/worldsims"},
            { name: "Egypt", search_name: "egypt", handle_name: "egypt", link: "/collections/egypt-esim"},
            { name: "Kenya", search_name: "kenya", handle_name: "kenya", link: "/collections/kenya-esim"},
            { name: "Madagascar", search_name: "madagascar", handle_name: "madagascar", link: "/collections/worldsims"},
            { name: "Morocco", search_name: "morocco", handle_name: "morocco", link: "/collections/morocco-esim"},
            { name: "Nigeria", search_name: "nigeria", handle_name: "nigeria", link: "/collections/worldsims"},
            {
                name: "Republic of the Congo",
                search_name: "republic-of-the-congo",
                handle_name: "republic-of-the-congo",
                link: "/collections/worldsims"},
            { name: "South Africa", search_name: "south africa", handle_name: "south-africa", link: "/collections/south-africa-esim"},
            { name: "Tanzania", search_name: "tanzania", handle_name: "tanzania", link: "/collections/tanzania-sim-card"},
            { name: "Tunisia", search_name: "tunisia", handle_name: "tunisia", link: "/collections/worldsims"},
            { name: "Uganda", search_name: "uganda", handle_name: "uganda", link: "/collections/worldsims"},
            { name: "Zambia", search_name: "zambia", handle_name: "zambia", link: "/collections/worldsims" },
        ],
        regional_name: [{ name: "Africa", search_name: "africa", handle_name: "africa", link: "/collections/worldsims"}],
    },
    {
        country_name: "asia",
        country_handle: "asia",
        country_title: [
            { name: "Bangladesh", search_name: "bangladesh", handle_name: "bangladesh", link: "/collections/bangladesh-sim-card"},
            { name: "Bali", search_name: "indonesia,bali", handle_name: "indonesia", link: "/collections/bali-esim"},
            { name: "Cambodia", search_name: "cambodia", handle_name: "cambodia", link: "/collections/cambodia-esim"},
            { name: "China", search_name: "china", handle_name: "china", link: "/collections/china-esim"},
            { name: "Hong Kong", search_name: "hong kong", handle_name: "hong-kong", link: "/collections/hong-kong-esim"},
            { name: "India", search_name: "india", handle_name: "india", link: "/collections/india-esim"},
            { name: "Japan", search_name: "japan", handle_name: "japan", link: "/collections/japan-esims"},
            { name: "Kazakhstan", search_name: "kazakhstan", handle_name: "kazakhstan", link: "/collections/kazakhstan-sim-card"},
            { name: "Kyrgyzstan", search_name: "kyrgyzstan", handle_name: "kyrgyzstan", link: "/collections/kyrgyzstan-sim-card"},          
            { name: "Laos", search_name: "laos", handle_name: "laos", link: "/collections/laos-sim-card"},
            { name: "Macau", search_name: "macau", handle_name: "macau", link: "/collections/macau-esim"},
            { name: "Malaysia", search_name: "malaysia", handle_name: "malaysia", link: "/collections/malaysia-esim"},
            { name: "Nepal", search_name: "nepal", handle_name: "nepal", link: "/collections/nepal-sim-card"},
            { name: "Pakistan", search_name: "pakistan", handle_name: "pakistan", link: "/collections/pakistan-sim-card"},
            { name: "Philippines", search_name: "philippines", handle_name: "philippines", link: "/collections/philippines-esim"},
            { name: "Singapore", search_name: "singapore", handle_name: "singapore", link: "/collections/singapore-esim"},
            { name: "South Korea", search_name: "south korea", handle_name: "south-korea", link: "/collections/south-korea-esim"},
            { name: "Sri Lanka", search_name: "sri lanka", handle_name: "sri-lanka", link: "/collections/sri-lanka-sim-card"},
            { name: "Taiwan", search_name: "taiwan", handle_name: "taiwan", link: "/collections/taiwan-esim"},
            { name: "Thailand", search_name: "thailand", handle_name: "thailand", link: "/collections/thailand-esim"},
            { name: "Uzbekistan", search_name: "uzbekistan", handle_name: "uzbekistan", link: "/collections/uzbekistan-sim-card"},
            { name: "Vietnam", search_name: "vietnam", handle_name: "vietnam", link: "/collections/vietnam-esim"},
        ],
        regional_name: [{ name: "Asia", search_name: "asia", handle_name: "asia", link: "/collections/asia-esim"}],
    },
    {
        country_name: "europe & uk",
        country_handle: "europe-uk",
        country_title: [
            { name: "Andorra", search_name: "andorra", handle_name: "andorra", link: "/collections/andorra-esim"},
            { name: "Aland Islands", search_name: "aland islands", handle_name: "aland-islands", link: "/collections/aland-islands-esim"},
            { name: "Albania", search_name: "albania", handle_name: "albania", link: "/collections/albania-esim"},
            { name: "Austria", search_name: "austria", handle_name: "austria", link: "/collections/austria-esim"},
            { name: "Azores", search_name: "azores", handle_name: "azores", link: "/collections/azores-sim-card"},
            { name: "Belgium", search_name: "belgium", handle_name: "belgium", link: "/collections/belgium-esim"},
            { name: "Bulgaria", search_name: "bulgaria", handle_name: "bulgaria", link: "/collections/bulgaria-esim"},
            { name: "Canary Islands", search_name: "canary islands", handle_name: "canary-islands", link: "/collections/canary-islands-esim"},
            { name: "Croatia", search_name: "croatia", handle_name: "croatia", link: "/collections/croatia-esim"},
            { name: "Cyprus", search_name: "cyprus", handle_name: "cyprus", link: "/collections/cyprus-esim"},
            { name: "Czech Republic", search_name: "czech republic", handle_name: "czech-republic", link: "/collections/czech-republic-esim"},
            { name: "Denmark", search_name: "denmark", handle_name: "denmark", link: "/collections/denmark-esim"},
            { name: "England", search_name: "england", handle_name: "england", link: "/collections/england-esim"},
            { name: "Estonia", search_name: "estonia", handle_name: "estonia", link: "/collections/estonia-esim"},
            { name: "Finland", search_name: "finland", handle_name: "finland", link: "/collections/finland-esim"},
            { name: "France", search_name: "france", handle_name: "france", link: "/collections/france-esim"},
            { name: "French Guiana", search_name: "french guiana", handle_name: "french-guiana", link: "/collections/french-guiana-sim-card"},
            { name: "Germany", search_name: "germany", handle_name: "germany", link: "/collections/germany-esim"},
            { name: "Gibraltar", search_name: "gibraltar", handle_name: "gibraltar", link: "/collections/gibraltar-esim"},
            { name: "Greece", search_name: "greece,rhodes island", handle_name: "greece", link: "/collections/greece-esim"},
            { name: "Guadeloupe", search_name: "guadeloupe", handle_name: "guadeloupe", link: "/collections/guadeloupe-sim-card"},
            { name: "Guernsey", search_name: "guernsey", handle_name: "guernsey", link: "/collections/guernsey-esim"},
            { name: "Hungary", search_name: "hungary", handle_name: "hungary", link: "/collections/hungary-esim"},
            { name: "Iceland", search_name: "iceland", handle_name: "iceland", link: "/collections/iceland-esim"},
            { name: "Ireland", search_name: "ireland", handle_name: "ireland", link: "/collections/ireland-esim"},
            { name: "Italy", search_name: "italy,sardinia,sicily", handle_name: "italy", link: "/collections/italy-esim"},
            { name: "Jersey", search_name: "jersey", handle_name: "jersey", link: "/collections/jersey-esim"},
            { name: "Latvia", search_name: "latvia", handle_name: "latvia", link: "/collections/latvia-esim"},
            { name: "Liechtenstein", search_name: "liechtenstein", handle_name: "liechtenstein", link: "/collections/liechtenstein-esim"},
            { name: "Lithuania", search_name: "lithuania", handle_name: "lithuania", link: "/collections/lithuania-esim"},
            { name: "Luxembourg", search_name: "luxembourg", handle_name: "luxembourg", link: "/collections/europe-luxembourg-esims"},
            { name: "Malta", search_name: "malta", handle_name: "malta", link: "/collections/malta-esim"},
            { name: "Montenegro", search_name: "montenegro", handle_name: "montenegro", link: "/collections/montenegro-esim"},
            { name: "Moldova", search_name: "moldova", handle_name: "moldova", link: "/collections/moldova-esim"},
            { name: "Netherlands", search_name: "netherlands", handle_name: "netherlands", link: "/collections/netherlands-esim"},
            { name: "Norway", search_name: "Norway", handle_name: "norway", link: "/collections/norway-esim"},
            { name: "Poland", search_name: "poland", handle_name: "poland", link: "/collections/poland-esim"},
            { name: "Portugal", search_name: "portugal,madeira", handle_name: "portugal", link: "/collections/portugal-esim"},
            { name: "Romania", search_name: "romania", handle_name: "romania", link: "/collections/romania-esim"},
            { name: "Serbia", search_name: "serbia", handle_name: "serbia", link: "/collections/serbia-esim"},
            { name: "Scotland", search_name: "scotland", handle_name: "scotland", link: "/collections/scotland-esim"},
            { name: "Slovakia", search_name: "slovakia", handle_name: "slovakia", link: "/collections/slovakia-esim"},
            { name: "Slovenia", search_name: "slovenia", handle_name: "slovenia", link: "/collections/slovenia-esim"},
            { name: "Spain", search_name: "spain,balearic islands", handle_name: "spain", link: "/collections/spain-esim"},
            { name: "Sweden", search_name: "sweden", handle_name: "sweden", link: "/collections/sweden-esim"},
            { name: "Switzerland", search_name: "switzerland", handle_name: "switzerland", link: "/collections/switzerland-esim"},
            { name: "Ukraine", search_name: "ukraine", handle_name: "ukraine", link: "/collections/ukraine-esim"},
            {
                name: "United Kingdom (UK)",
                search_name: "united kingdom (uk),northern ireland,isle of man,wales,isle of wight",
                search_extra: "uk",
                handle_name: "united-kingdom-uk",
                link: "/collections/uk-europe-prepaid-sims"},
            { name: "Vatican City", search_name: "vatican city", handle_name: "vatican-city", link: "/collections/vatican-city-esim"},
        ],
        regional_name: [{ name: "Europe & UK", search_name: "europe & uk", handle_name: "europe-uk", link: "/collections/uk-europe-prepaid-sims"}],
    },
    {
        country_name: "middle east",
        country_handle: "middle-east",
        country_title: [
            { name: "Armenia", search_name: "armenia", handle_name: "armenia", link: "/collections/armenia-sim-card"},
            { name: "Azerbaijan", search_name: "azerbaijan", handle_name: "azerbaijan", link: "/collections/azerbaijan-sim-cards"},
            { name: "Bahrain", search_name: "bahrain", handle_name: "bahrain", link: "/collections/bahrain-sim-card"},
            { name: "Israel", search_name: "israel", handle_name: "israel", link: "/collections/israel-esim"},
            { name: "Jordan", search_name: "jordan", handle_name: "jordan", link: "/collections/jordan-sim-card"},
            { name: "Kuwait", search_name: "kuwait", handle_name: "kuwait", link: "/collections/kuwait-sim-card"},
            { name: "Oman", search_name: "oman", handle_name: "oman", link: "/collections/oman-sim-card"},
            { name: "Qatar", search_name: "qatar", handle_name: "qatar", link: "/collections/qatar-sim-card"},
            { name: "Saudi Arabia", search_name: "saudi arabia", handle_name: "saudi-arabia", link: "/collections/saudi-arabia-esim"},
            { name: "Turkey", search_name: "turkey", handle_name: "turkey", link: "/collections/turkey-esim"},
            {
                name: "United Arab Emirates (Dubai)",
                search_name: "united arab emirates (dubai),uae",
                search_extra: "uae,dubai",
                handle_name: "united-arab-emirates-dubai",
                link: "/collections/united-arab-emirates-esim"},
        ],
        regional_name: [{ name: "Middle East", search_name: "middle east", handle_name: "middle-east"}],
    },
    {
        country_name: "oceania",
        country_handle: "oceania",
        country_title: [
            { name: "Fiji", search_name: "fiji", handle_name: "fiji", link: "/collections/fiji-esim"},
            { name: "New Zealand", search_name: "new zealand", handle_name: "new-zealand", link: "/collections/new-zealand-esim"},
        ],
        regional_name: [{ name: "Oceania", search_name: "oceania", handle_name: "oceania", link: "/collections/new-zealand-esim"}],
    },
    {
        country_name: "south america",
        country_handle: "south-america",
        country_title: [
            { name: "Argentina", search_name: "argentina", handle_name: "argentina", link: "/collections/argentina-sim-card"},
            { name: "Brazil", search_name: "brazil", handle_name: "brazil", link: "/collections/brazil-sim-card"},
            { name: "Chile", search_name: "chile", handle_name: "chile", link: "/collections/chile-sim-card"},
            { name: "Colombia", search_name: "colombia", handle_name: "colombia", link: "/collections/colombia-sim-card"},
            { name: "Costa Rica", search_name: "costa rica", handle_name: "costa-rica", link: "/collections/costa-rica-sim-card"},
            { name: "Ecuador", search_name: "ecuador", handle_name: "ecuador", link: "/collections/ecuador-sim-card"},
            { name: "El Salvador", search_name: "el salvador", handle_name: "el-salvador", link: "/collections/el-salvador-sim-card"},
            { name: "Guatemala", search_name: "guatemala", handle_name: "guatemala", link: "/collections/guatemala-sim-card"},
            { name: "Honduras", search_name: "honduras", handle_name: "honduras", link: "/collections/honduras-sim-card"},
            { name: "Nicaragua", search_name: "nicaragua", handle_name: "nicaragua", link: "/collections/nicaragua-sim-card"},
            { name: "Panama", search_name: "panama", handle_name: "panama", link: "/collections/panama-sim-card"},
            { name: "Paraguay", search_name: "paraguay", handle_name: "paraguay", link: "/collections/paraguay-sim-card"},
            { name: "Peru", search_name: "peru", handle_name: "peru", link: "/collections/peru-esim"},
            { name: "Puerto Rico", search_name: "puerto rico", handle_name: "puerto-rico", link: "/collections/puerto-rico-sim-card"},
            { name: "Uruguay", search_name: "uruguay", handle_name: "uruguay", link: "/collections/uruguay-sim-card"},
        ],
        regional_name: [{ name: "South America", search_name: "south america", handle_name: "south-america", link: "/collections/south-america-prepaid-sim-cards"}],
    },
    {
        country_name: "North America",
        country_handle: "usa",
        country_title: [
            { name: "Alaska", search_name: "alaska", handle_name: "alaska", link: "products/usa-alaska-canada-esim"},
            { name: "Canada", search_name: "canada", handle_name: "canada", link: "/collections/canada-esim"},
            { name: "Hawaii", search_name: "hawaii", handle_name: "hawaii", link: "/collections/hawaii-esim"},
            { name: "Mexico", search_name: "mexico", handle_name: "mexico", link: "/collections/mexico-esim"},
            {
                name: "United States of America (USA)",
                search_name: "united states of america (usa),hawaii",
                search_extra: "usa,hawaii",
                handle_name: "united-states-of-america-usa",
                link: "/collections/united-states-esim"},
        ],
        regional_name: [
            {
                name: "North America",
                search_name: "usa",
                handle_name: "usa",
                link: "/collections/north-america-prepaid-esims"},
        ],
    },
];



// Close modal and reset search
$(document).on("click", ".close-modal, .destination-modal", function () {
    // Clear the search input field
    $(".destination-search").val("");
  
    // Reset the search result display
    $(".popular-destinations").removeClass('active_value');
    $(".designation, .destination-list").show(); // Show the default list view
    $(".country_result, .country_region, .no-search-item").hide(); // Hide search results
});
  // Flatten countries and regions
  const destinationsData = {
    countries: [],
    regions: []
  };

  SearchResultJson.forEach(entry => {
    // Extract countries
    if (entry.country_title) {
      entry.country_title.forEach(country => {
        destinationsData.countries.push({
          name: country.name,
          link: country.link,
          region: entry.country_name
        });
      });
    }

    // Extract regions
    if (entry.regional_name) {
      entry.regional_name.forEach(region => {
        destinationsData.regions.push({
          name: region.name,
          link: region.link
        });
      });
    }
  });

  // Search functionality
$(".destination-search").on("keyup", function () {
    const value = $(this).val().toLowerCase().trim();
  $('.popular-destinations').addClass('active_value');
    if (value.length > 0) {
      $(".designation, .destination-list").hide();
    } else {
      $(".designation, .destination-list").show();
      $(".country_result, .country_region, .no-search-item").hide();
      return;
    }

    const $countryList = $(".country_result .country-items").empty();
    const $regionList = $(".country_region .region-items").empty();
    let foundMatch = false;
    const matchedRegionNames = new Set();

  
// Reset match tracking
matchedRegionNames.clear();


// Build a map: regionName => array of country names
const regionToCountries = {};




// Filter countries only — we will NOT search regions by user input
destinationsData.countries.forEach(country => {
  if (country.name.toLowerCase().includes(value)) {

let fileName = country.name
  .toLowerCase()
  .replace(/[()]/g, '')       // remove only parentheses
  .replace(/\s+/g, '_');      // replace spaces with underscore

let flagImg = `
  <img 
    src="https://cdn.shopify.com/s/files/1/0207/0190/4996/files/menu_${fileName}.svg"
    alt="${country.name} flag"
    style="width:24px; height:24px; margin-left:5px;"
    onerror="this.parentElement.style.display='none';"
  >
`;



    $countryList.append(`
      <li class="list-item">
        <div class="title-wrapper">
          <a href="${country.link || '#'}" class="list-link" style="align-items: center; text-decoration: none;">
           <span class="title-name">${country.name}</span>
            <div class="flag-icon" style="display:flex; align-items:center;">
              ${flagImg}
            </div>
           
          </a>
        </div>
      </li>
    `);

    if (country.region) matchedRegionNames.add(country.region.toLowerCase());
    foundMatch = true;
  }
});
const regionFlags = {
  "north america": ["USA","Canada", "Mexico"],  
  "europe & uk": ["United Kingdom (UK)", "France","Italy","Germany","Spain"], 
  "asia": ["China","South Korea", "Japan", "Thailand","Indonesia", "Singapore"],
  "africa": ["Egypt", "South Africa","Nigeria","Zambia","Morocco"],
  "south america": ["Brazil", "Argentina","Chile","Costa Rica","Colombia","Peru"],
  "oceania": ["New Zealand","Fiji"],
  "middle east": ["UAE", "Qatar","Turkey","Egypt","Saudi Arabia"]
};

destinationsData.countries.forEach(country => {
  const regionName = country.region.toLowerCase();
  if (!regionToCountries[regionName]) regionToCountries[regionName] = [];
  regionToCountries[regionName].push(country.name);
});

// Show region only if it was associated with a matched country
destinationsData.regions.forEach(region => {
  const regionName = region.name.toLowerCase();
  if (matchedRegionNames.has(regionName)) {

    // Generate flag images for countries in this region, limit to 6
    let flagsHtml = '';
  if (regionFlags[regionName]) {
  regionFlags[regionName].forEach(countryName => {
    const fileName = countryName
      .toLowerCase()
      .replace(/[()]/g, '')
      .replace(/[,&]/g, '')
      .replace(/\s+/g, '_');

    flagsHtml += `
      <img 
        src="https://cdn.shopify.com/s/files/1/0207/0190/4996/files/menu_${fileName}.svg"
        alt="${countryName} flag"
        style="width:24px; height:24px; margin-left:2px;"
        onerror="this.style.display='none';"
      >
    `;
  });
}


    $regionList.append(`
      <li class="list-item" link="${region.link || '#'}">
        <div class="title-wrapper">
          <a href="${region.link || '#'}" class="list-link" style="align-items: center; text-decoration: none;">
          <span class="title-name">${region.name}</span>
            <div class="flag-icon" style="display:flex; align-items:center;flex-direction: row;">
              ${flagsHtml}
            </div>
            
          </a>
        </div>
      </li>
    `);
  }
});


    $(".country_result").toggle($countryList.children().length > 0);
    $(".country_region").toggle($regionList.children().length > 0);
    $(".no-search-item").toggle(!foundMatch);
  });

  // Navigation
$(document).on("click", ".list-item", function () {
    const link = $(this).attr("link");
    if (link) window.location.href = link;
  });

  //  search modal js main banner end

// faq section start

$('.custom-tab').on('click', function () {
      // Remove 'active' from all tab headers
      $('.tab__list').removeClass('active');
      $(this).closest('.tab__list').addClass('active');

      // Hide all tab contents
      $('.tab-content').addClass('hidden');

      // Show the one matching the clicked tab
      const targetId = $(this).data('content-id');
      $('#' + targetId).removeClass('hidden');
    });

function close_accordion_section() {
    $('.accordion .accordion-section-title').removeClass('active');
    $('.accordion .accordion-section-content').slideUp(300).removeClass('open');
    $('.accordion .custom_plus').show();    
    $('.accordion .icon-minus').hide();   
}

$('.accordion-section-title').click(function(e) {
    e.preventDefault();

    var currentAttrValue = $(this).attr('href');

    if ($(this).hasClass('active')) {
        // Closing the same section
        close_accordion_section();
    } else {
        // Open clicked section
        close_accordion_section();

        $(this).addClass('active');
        $('.accordion ' + currentAttrValue).slideDown(300).addClass('open');

        // Toggle icons correctly
        $(this).find('.custom_plus').hide();
        $(this).find('.icon-minus').show();
    }
});

  // faq section end
});

$(document).ready(function () {
  let menuTimer;

  // Hover on summary (button)
  $(".site-nav__details summary").on("mouseenter", function () {
    clearTimeout(menuTimer); // prevent closing
    let $summary = $(this);
    let $details = $summary.parent();

    // Close all others
    $(".site-nav__details").not($details).removeAttr("open");
    $(".site-nav__details summary").not($summary).removeClass("active").attr("aria-expanded", "false");

    // Open current
    $details.attr("open", true);
    $summary.addClass("active").attr("aria-expanded", "true");
    $("header").addClass("menu-open");
  });

  // Handle mouseleave for entire megamenu block
  $(".site-nav__details, .destination-megamenu-12").on("mouseleave", function () {
    // Start short timeout to allow buffer
    menuTimer = setTimeout(() => {
      $(".site-nav__details").removeAttr("open");
      $(".site-nav__details summary").removeClass("active").attr("aria-expanded", "false");
      $("header").removeClass("menu-open");
    }, 100); // adjust delay if needed
  }).on("mouseenter", function () {
    clearTimeout(menuTimer); 
  });

  // Tab switching logic
  $('.destination-links-12 .tab-link').on('mouseenter', function () {
    let $parentLi = $(this).closest('.custom_class_links');
    if (!$parentLi.hasClass('active_tab')) {
      $('.custom_class_links').removeClass('active_tab');
      $parentLi.addClass('active_tab');

      let text = $(this).text().trim().toLowerCase();
      showDestinationContent(text);
    }
  });

  function showDestinationContent(text) {
    $('.destination-grid-12').hide();
    // $('.destination-grid-12').each(function () {
    //   if ($(this).data('content').toLowerCase() === text) {
    //     $(this).show();
    //   }
    // });

    $('.destination-grid-12').each(function () {
  const content = $(this).data('content');
  if (typeof content === 'string' && content.toLowerCase() === text) {
    $(this).show();
  }
});
// Show "View All" button only for 'country' tab
  if (text === 'country') {
    $('.view_alll').show();
  } else {
    $('.view_alll').hide();
  }

  }

  // Show default active tab
  if ($('.custom_class_links.active_tab').length === 0) {
    $('.custom_class_links').first().addClass('active_tab');
  }

  let $active = $('.custom_class_links.active_tab .tab-link');
  if ($active.length) {
    let defaultText = $active.text().trim().toLowerCase();
    showDestinationContent(defaultText);
  }
// });


   $('.destination-search_value').on('keyup', function () {
      var query = $(this).val().trim().toLowerCase();

      $('.custom_class_links').each(function () {
        var linkText = $(this).find('a').text().trim().toLowerCase();
        if (linkText.indexOf(query) > -1) {
          $(this).show(); // Match found
        } else {
          $(this).hide(); // Hide if no match
        }
      });
    });

    // header megamenu section end
});

$('.destination-search_value').on('keyup', function () {
  var query = $(this).val().trim().toLowerCase();

  $('.custom_class_links').each(function () {
    var linkText = $(this).find('a').text().trim().toLowerCase();
    if (linkText.indexOf(query) > -1) {
      $(this).show(); // Match found
    } else {
      $(this).hide(); // Hide if no match
    }
  });
});

$(document).ready(function () {
  $('.popular-destinations-wrapper').each(function () {
    var $wrapper = $(this);

    $wrapper.find('.destination-tab').on('click', function () {
      var target = $(this).data('tab');

      $wrapper.find('.destination-tab').removeClass('active-cou');
      $(this).addClass('active-cou');

      $wrapper.find('.destination-tab-content').removeClass('active-cou').hide();
      $wrapper.find(target).addClass('active-cou').fadeIn();
    });
  });
});

// popular snipes slideshow banner section
document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.tab-button');
  tabs.forEach(btn => {
    btn.addEventListener('click', function() {
      tabs.forEach(b => b.classList.remove('active_desti'));
      this.classList.add('active_desti');

      const sel = this.getAttribute('data-tab');
      document.querySelectorAll('.tab-panel').forEach(panel => {
        panel.id === sel + '-panel'
          ? panel.classList.remove('hidden')
          : panel.classList.add('hidden');
      });
    });
  });
});



 jQuery(document).ready(function($) {
      
  // Show popup
  function showPopup(content) {
    $('#unitw-popup-body').html(content);
    $('#unitw-popup-overlay').fadeIn();
  }

  // Close popup on close button
  $('#unitw-popup-close').on('click', function() {
    $('#unitw-popup-overlay').fadeOut();
  });

  // Close popup on clicking outside content
  $('#unitw-popup-overlay').on('click', function(e) {
    if ($(e.target).is('#unitw-popup-overlay')) {
      $('#unitw-popup-overlay').fadeOut();
    }
  });

  // Handle .premium click inside anchor
 $(document).on('click', '.premium', function(e) {
    e.preventDefault();
    e.stopPropagation();
    let clickedContent = $(this).html();
    let coveredCountries = $(this).data('covered'); // metafield data
    let productUrl = $(this).closest('a').attr('href');

    let combinedContent = `
    <div>
      <h3 class="extra-content">${clickedContent}</h3>
      ${coveredCountries}
      </div>
      <div>
      <a href="${productUrl}" class="popup-product-link">
      View SIM
    </a>
    <div style="opacity:0;height: 9px;">Test</div>
    </div>
    `;

    showPopup(combinedContent);
});

});


document.addEventListener('DOMContentLoaded', function () {
    let previouslyOpenedTab = null;
    let previouslyRotatedIcon = null;

    document.querySelectorAll('.custom_button_render .collapsible-trigger__icon').forEach(function (icon) {
      icon.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        const tabWrapper = icon.closest('.custom_button_render');
        const tabContent = tabWrapper?.nextElementSibling;

        if (!tabContent || !tabContent.classList.contains('custom-tab-content')) return;

        // Close previously opened tab if it's not the current one
        if (previouslyOpenedTab && previouslyOpenedTab !== tabContent) {
          previouslyOpenedTab.classList.remove('active');
          previouslyOpenedTab.style.display = 'none';
          if (previouslyRotatedIcon) {
            previouslyRotatedIcon.classList.remove('rotated');
          }
        }

        // Toggle current tab
        const isActive = tabContent.classList.toggle('active');
        tabContent.style.display = isActive ? 'block' : 'none';
        icon.classList.toggle('rotated', isActive);

        // Update references
        previouslyOpenedTab = isActive ? tabContent : null;
        previouslyRotatedIcon = isActive ? icon : null;

        // Optional: Add custom height class to open sublist
        const openSublist = document.querySelector('.mobile-nav__sublist.collapsible-content.collapsible-content--all.is-open');
        if (openSublist && !openSublist.classList.contains('custom_height')) {
          openSublist.classList.add('custom_height');
        }
      });
    });

    // jQuery for toggle button to close all tabs and remove custom_height
    $('.mobile-nav__toggle').on('click', function () {
      // Remove custom height
      $('.mobile-nav__sublist.collapsible-content--all.is-open').removeClass('custom_height');

      // Hide all open tab contents and remove 'active'
      $('.custom-tab-content.active').each(function () {
        $(this).removeClass('active').hide();
      });

      // Remove rotation from icons
      $('.collapsible-trigger__icon').removeClass('rotated');

      // Reset JS references (to prevent stale tracking)
      previouslyOpenedTab = null;
      previouslyRotatedIcon = null;
    });
  });

// $(document).ready(function () {
//   // Filter function
//   function filterProducts(plan) {
//     let visibleCount = 0;

//     $('.grid__item.grid-product').each(function () {
//       const productTag = $(this).find('.grid-product__tag').text().trim();

//       // Show all if 'all-plans' is selected
//       if (plan === 'all-plans' || plan === '') {
//         $(this).show();
//         visibleCount++;
//       } else {
//         // Show only matching products
//         if (productTag === plan) {
//           $(this).show();
//           visibleCount++;
//         } else {
//           $(this).hide();
//         }
//       }
//     });

//     // Show or hide 'No products found' message
//     if (visibleCount === 0) {
//       $('#no-products-message').show();
//     } 
//     else {
//       $('#no-products-message').hide();
//     }
//   }
             
//   // Click handler
//   $('.collection_values').on('click', function () {
//     $('.collection_values').removeClass('active_plan');
//     $(this).addClass('active_plan');

//     const selectedPlan = $(this).data('plan');
//     console.log('Selected Plan:', selectedPlan);

//     filterProducts(selectedPlan);
//   });

//   // Trigger first button click on load (default state)
//   $('.collection_values').first().trigger('click');
// });


$(document).ready(function () {
  // Filter function
  function filterProducts(plan) {
  let visibleCount = 0;

  $('.grid__item.grid-product').each(function () {
    const productTags = $(this).data('tags'); 
    const tagList = productTags ? productTags.split(',').map(t => t.trim()) : [];

    if (plan === 'all-plans') {
      $(this).removeClass('filtered-out');
      visibleCount++;
    } else {
      if (tagList.includes(plan)) {
        $(this).removeClass('filtered-out');
        visibleCount++;
      } else {
        $(this).addClass('filtered-out');
      }
    }
  });

  if (visibleCount === 0) {
    $('#no-products-message').show();
  } else {
    $('#no-products-message').hide();
  }
}


  // Click handler
  $('.collection_values').on('click', function () {
    $('.collection_values').removeClass('active_plan');
    $(this).addClass('active_plan');

    const selectedPlan = $(this).data('plan');
    console.log('Selected Plan:', selectedPlan);

    filterProducts(selectedPlan);
  });

  // Trigger first button click on load
  $('.collection_values').first().trigger('click');
});



$(document).ready(function () {
  // Add class to 'Compatibility' link
$(".menu-item a, .site-footer__linklist li a").each(function () {
  const text = $(this).text().trim();
  if (text.toLowerCase() === "compatibility") {
    $(this).addClass("custom-search-popup");
  }
});


  $(".menu-item a, .mobile-nav__link").each(function () {
  const text = $(this).text().trim();
  if (text === "Compatibility") {
    $(this).addClass("custom-search-popup");
  }
});

  // Open Popup
  $(document).on("click", "a.custom-search-popup", function (e) {
    e.preventDefault();
    $("#compatibilityPopup").fadeIn();
  });

  // Close function
  function closeCompatibilityPopup() {
    $("#compatibilityPopup").fadeOut();
    $("#compatibilityDeviceSearch").val(""); // clear search input
    $("#autocompleteResults").hide();        // hide autocomplete results
  }

  // Close on close button click
  $(document).on("click", ".compatibility-close-popup", function () {
    closeCompatibilityPopup();
  });

  // Close on clicking outside popup content
  $(document).on("click", "#compatibilityPopup", function (e) {
    if (!$(e.target).closest(".compatibility-popup-content").length) {
      closeCompatibilityPopup();
    }
  });
  
 $(document).on("click", ".compatibility-tab-content", function (e) {
   
      $("#autocompleteResults").hide();  // Hide autocomplete when clicking on the popup
    
  });
  // Tab Button Click
  $(".compatibility-tab-btn").on("click", function () {
    const tab = $(this).data("tab");

    $(".compatibility-tab-btn").removeClass("active-comaptibility");
    $(this).addClass("active-comaptibility");

    $(".compatibility-tab-content").removeClass("active-comaptibility");
    $('.compatibility-tab-content[data-tab="' + tab + '"]').addClass("active-comaptibility");

    $("#compatibilityDeviceSearch").val("");
    $("#autocompleteResults").hide();
     // ✅ ADD THIS LINE
  renderTabDevices(tab);
  });

  // Device Data & Search Logic
 // ✅ Get data from JSON script
const deviceData = JSON.parse(document.getElementById("device-data-json").textContent);

// ✅ Function to render list on tab open
function renderTabDevices(tab) {
  const devices = deviceData[tab.toLowerCase()] || [];
  const $ul = $('.device-list[data-tab="' + tab + '"]');

  $ul.html(
    devices.map(device => `<li class="compatibility-values">${device}</li>`).join("")
  );
}

// ✅ Load default active tab on page load
$(document).ready(function () {
  const activeTab = $(".compatibility-tab-btn.active-comaptibility").data("tab");
  if (activeTab) {
    renderTabDevices(activeTab);
  }
});

  $("#compatibilityDeviceSearch").on("input", function () {
    const query = $(this).val().toLowerCase();
    const $results = $("#autocompleteResults").empty();

    if (query.length < 2) {
      $results.hide();
      return;
    }

    let found = false;
    $.each(deviceData, function (brand, models) {
      const brandMatch = brand.toLowerCase().includes(query);
      const modelMatches = models.filter(m => m.toLowerCase().includes(query));

      if (brandMatch || modelMatches.length > 0) {
        found = true;
      const globalImageUrl = document.getElementById("global-search-image")?.dataset.url;

        $results.append('<div class="autocomplete-group">' + brand.charAt(0).toUpperCase() + brand.slice(1) + '</div>');

        const modelsToShow = brandMatch ? models : modelMatches;
        modelsToShow.forEach(model => {
          $results.append(
  '<div class="autocomplete-item" data-brand="' + brand + '">' +
    (globalImageUrl ? '<img src="' + globalImageUrl + '" class="auto-img"> ' : '') +
    model +
  '</div>'
);

        });
      }
    });

    if (!found) {
      $results
        .append('<div class="autocomplete-item" style="color:#999; cursor:default;">Device not found. Check compatibility using EID</div>')
        .show();
    } else {
      $results.show();
    }
  });
});


